import { Question } from '_models/question';

/** Preferred answers for common IDs (aligned with aidquiz e2e happy path). */
export const TEST_DEFAULT_BY_ID: Record<string, string> = {
  'parent.siblingCount': '1',
  'parent.siblingAge1': '18',
  'parent.siblingAttendCollegeCode1': 'no',
  'parent.siblingCollegeTypeCode1': '',
  'student.birthYear': '2008',
};

/** When no fixed value is set, prefer these Code labels by question id. */
export const TEST_CODE_LABEL_PREFERENCES: Record<string, RegExp[]> = {
  'parent.maritalStatus': [/married/i],
  'parent.maritalStatusCode': [/married/i],
  'parent.stateOfResidence': [/\bGA\b|georgia/i],
  'parent.state': [/\bGA\b|georgia/i],
  'parent.homeOwnerIndicator': [/^no$/i],
  'student.birthYear': [/2008/],
};

export function defaultTestValue(
  q: Question,
  allowedChoiceValues: string[] | null,
): string {
  // Sibling list owns these; `no` = not in college.
  if (/^parent\.siblingAttendCollegeCode\d+$/.test(q.id)) {
    return TEST_DEFAULT_BY_ID[q.id] ?? 'no';
  }
  if (/^parent\.siblingCollegeTypeCode\d+$/.test(q.id)) {
    return TEST_DEFAULT_BY_ID[q.id] ?? '';
  }

  const preferred = TEST_DEFAULT_BY_ID[q.id];
  if (q.format === 'Code') {
    return pickChoice(
      q,
      preferred !== undefined ? [preferred] : [],
      TEST_CODE_LABEL_PREFERENCES[q.id] ?? [],
      allowedChoiceValues,
    ) ?? '';
  }
  if (preferred !== undefined) {
    return preferred;
  }

  switch (q.format) {
    case 'Boolean':
      return 'no';
    case 'Number':
    case 'NumberAllowNegative':
      return '0';
    case 'Integer':
      return '1';
    case 'TextAsNumber':
      return '30301';
    case 'Text':
      return 'Test';
    default:
      return '';
  }
}

export function pickChoice(
  q: Question,
  preferredValues: string[],
  labelPatterns: RegExp[],
  allowedChoiceValues: string[] | null,
): string | null {
  const choices = (q.choices ?? []).filter(c =>
    !allowedChoiceValues || allowedChoiceValues.includes(String(c.value))
  );
  for (const value of preferredValues) {
    if (choices.some(c => String(c.value) === value)) {
      return value;
    }
  }
  for (const pattern of labelPatterns) {
    const match = choices.find(c => pattern.test(String(c.label)));
    if (match) {
      return String(match.value);
    }
  }
  return choices.length ? String(choices[0].value) : null;
}

export function shouldSkipTestFill(q: Question): boolean {
  return !!(q.hidden || q.triggerHide || q.efcMethodologyHidden);
}
